import { mutatorAction } from 'satcheljs';
import ExternalImagesOptionType from '../store/schema/ExternalImagesOptionType';
import store from '../store/store';

/**
 * Mutator triggered when we change the option.
 */
export default mutatorAction('selectExternalImagesOption', (value: ExternalImagesOptionType) => {
    store().selectedOption = value;
});
